export const signUp = '/auth/createUser';
export const signIn = '/auth/login';
export const forgotPassword = '/auth/send-forgot-password-link';
export const setPassword = '/auth/reset-password';
